













































import { Vue, Component, Emit } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import VueSimpleSuggest from 'vue-simple-suggest'

type PatientListItem = {
  id: number
  name: string
  reading?: string
}
const SEARCH_HISOTRY_MAX = 10

@Component({
  components: { VueSimpleSuggest }
})
export default class PatientSearchField extends Vue {
  $store!: ExStore
  controls = {
    selectionUp: [38],
    selectionDown: [40],
    select: [],
    showList: [40],
    hideList: [27],
    autocomplete: [32, 13]
  }
  $refs!: {
    searchField: typeof VueSimpleSuggest
  }
  stopAutoSearch = false

  @Emit('select')
  onSelect(patient: PatientListItem | null) {
    if (patient) this.addToSearchHistory(patient)
    this.$store.dispatch('schedule/updateCalendar', {
      searchWord: patient ? patient.name : ''
    })
    return patient ? patient.id : null
  }

  get patients() {
    return this.$store.getters['team/patients']
  }

  get patientItems() {
    return this.patients.map(p => ({
      id: p.id,
      name: `${p.lastName}${p.firstName}`,
      reading: `${p.lastNameReading}${p.firstNameReading}`
    }))
  }

  async created() {
    await this.$store.dispatch('team/updatePatients')
  }

  get searchWord() {
    return this.calendarSetting.searchWord
  }

  set searchWord(searchWord: string) {
    this.$store.dispatch('schedule/updateCalendar', { searchWord })
  }

  get calendarSetting() {
    return this.$store.getters['schedule/calendar']
  }

  filter(item: PatientListItem, query: string) {
    const nameHit = item.name.indexOf(query.trim())
    const readingHit = item.reading ? item.reading.indexOf(query.trim()) : -1
    return nameHit >= 0 || readingHit >= 0
  }

  onCloseClick() {
    this.$refs.searchField?.clearSuggestions()
    this.searchWord = ''
    this.onSelect(null)
  }

  onFocus() {
    this.$refs.searchField?.setText(' ')
  }

  async onChange(searchWord: string) {
    if (this.stopAutoSearch) {
      this.stopAutoSearch = false
      this.$refs.searchField?.hideList()
      return
    }
    this.searchWord = searchWord
    if (searchWord === '') this.$refs.searchField?.clearSuggestions()
  }

  onSelectPatient(patient?: PatientListItem) {
    this.stopAutoSearch = true
    patient ? this.onSelect(patient) : this.onSelect(null)
    this.$refs.searchField?.clearSuggestions()
  }

  selectByEnter() {
    const data = this.$refs.searchField?.hovered
    if (!data) return
    this.stopAutoSearch = true
    this.$refs.searchField?.select(data)
    this.$refs.searchField?.clearSuggestions()
    this.onSelect(data)
  }

  async getHistoryListItems(list: PatientListItem[]) {
    const ids = this.getSearchHistory().map(item => item.id)
    return [
      ...this.getSearchHistory(),
      ...list.filter(item => !ids.includes(item.id))
    ]
  }

  addToSearchHistory(listItem: PatientListItem | undefined) {
    if (!listItem) return
    const history = this.getSearchHistory().filter(
      item => item.id !== listItem.id
    )
    const list = [listItem, ...history].slice(0, SEARCH_HISOTRY_MAX)
    this.setSearchHistory(list)
  }

  getSearchHistory() {
    const patients = this.patients.map(p => p.id)
    return (JSON.parse(
      localStorage.getItem('patientSearchHistory') || '[]'
    ) as PatientListItem[]).filter(p => patients.includes(p.id))
  }

  setSearchHistory(history: PatientListItem[]) {
    localStorage.setItem('patientSearchHistory', JSON.stringify(history))
  }
}
